import * as yup from 'yup';

import { IUpdateAIModelFileFormFields, IUploadAIModelFileForm } from './types';

export const UploadAIModelFileValidationSchema: yup.ObjectSchema<IUploadAIModelFileForm> =
	yup.object().shape({
		name: yup.string().required('Name is required'),
		description: yup
			.string()
			.max(255, 'Description must be at most 255 characters'),
		file: yup.mixed<File>().nullable().required('File is required'),
	});

export const UpdateAIModelFileValidationSchema: yup.ObjectSchema<IUpdateAIModelFileFormFields> =
	yup.object().shape({
		name: yup.string().required('Name is required'),
		description: yup
			.string()
			.max(255, 'Description must be at most 255 characters'),
	});
